import UiElement from '../../../shared/ui-element/ui-element';

export default class ContextApps extends UiElement {
  uiCollections = {
    contextAppsImages: '.context-apps__image',
  };

  animateContextApps = () => {
    this.uiCollections.contextAppsImages.forEach((appImage, index) => {
      appImage.classList.toggle(`context-apps__image-${index + 1}_animate`);
      appImage.classList.toggle('context-apps__image_animate');
    });
  };

  onInit() {
    super.onInit();

    this.animateContextApps();
  }
}
